import { Box, Tabs, Tab } from "@mui/material";
import React from "react";
import CutomerBookingTable from "../../features/manageCustomers/bookingTable";
import CustomPagination from "../../components/CustomPagination";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface BookingHistoryProps {
  hidePast?: boolean;
}

function BookingHistory({ hidePast = false }: BookingHistoryProps) {
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="cards table_cards v2">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="booking tabs"
            className="custom_tabs_links"
          >
            <Tab label="Upcoming Bookings" {...a11yProps(0)} />
            {!hidePast && <Tab label="Past Bookings" {...a11yProps(1)} />}
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <CutomerBookingTable />
        </CustomTabPanel>

        {!hidePast && (
          <CustomTabPanel value={valueTabs} index={1}>
            <CutomerBookingTable isPast={true} />
          </CustomTabPanel>
        )}
      </div>
      <CustomPagination />
    </>
  );
}

export default BookingHistory;
